<app-header></app-header>
<main class="pages">
    <section class="gradient-light">
        <div class="container pt-lg-5">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <!-- <nav aria-label="breadcrumb text-center pt-lg-5 pt-3">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a routerLink="">Home</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Events and Entertainment</li>
                        </ol>
                    </nav> -->
                    <h1 alt="event audience survey" class="h1-title mt-3">Get a 360<sup>&deg;</sup> Assessment of Your Event.</h1>
                    <p class="sub-text mt-3">With the help of CViewSurvey application, get ready insights on audience and visitors opinions on your event.</p>
                    <div class="mt-lg-5">
                        <a title="" class="btn btn-lg btn-success px-4 text-uppercase  mr-lg-2" data-toggle="modal" data-target="#callBack" id="callback">Request a Demo</a>
                    </div>
                </div>
                <div class="col-md-6 ">
                    <div class="page-banner-img">
                        <img class="img-fluid mt-3" alt="Event Survey" title="" src="assets/event-and-entertainment.svg">

                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="mb-5 pb-5">
        <div class="container">
            <div class="col-md-12">
                <div class="featured video card border-0 shadow mt-lg-5">
                    <div class="card-body">
                        <h2 alt="event survey example" class="text-center headings mb-4">Event & Entertainment</h2>
                        <p class="text-center sub-text">From a small event to a huge event, the road to successful attendance experience is based on the accuracy of the data and insights from the attendees. These surveys help you collect crucial details of your guests for a seamless
                            event experience.
                        </p>
                    </div>
                    <!-- play-video -->
                    <div class="play-video">
                        <a class="video-play-button" (click)="scroll(target)">
                            <span></span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="mt-5 mb-lg-5  pt-lg-5 pb-lg-5">
        <div class="container mb-lg-5">
            <h3 alt="event survey feedback questions" class="text-center">We help you evaluate attendee satisfaction pre, post and during your events</h3>
        </div>

        <div class="features-screenshot-right">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="lazy-image-wrapper loaded">
                            <img class="img-fluid px-lg-5 mb-3 mb-lg-0" alt="Pre Event and Entertainment Survey" src="assets/pre-event-survey.svg">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <h3 alt="event survey feedback questions" class="feature-heading">PRE- EVENT SURVEY</h3>
                        <p class="sub-text text-justify">With the help of our market survey application, you can head start your planning by getting to know relevant details about your attendees. Ensure your event is a big success, with CViewSurvey Events survey. Get a preview of your
                            event by understanding about your prospects timing preferences, willingness to attend etc.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="features-screenshot-left">
            <div class="container">
                <div class="row align-items-center mob-column-reverse">
                    <div class="col-md-6">
                        <h3 alt="event survey feedback questions" class="feature-heading">DURING EVENT SURVEY</h3>
                        <p class="sub-text text-justify">Conduct the surveys during the event for getting the live feedback of the event. During the event surveys are the best way to connect with participants and measure their first impression. This kind of survey helps you evaluate
                            the event and know about the pros and cons, so you can always act accordingly to make the event more lively and enjoyable, then and there.</p>
                    </div>
                    <div class="col-md-6">
                        <div class="lazy-image-wrapper loaded">
                            <img class="img-fluid px-lg-5 mb-3 mb-lg-0" alt="During Event Survey" src="assets/event-survey.svg">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="features-screenshot-right">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="lazy-image-wrapper loaded">
                            <img class="img-fluid px-lg-5 mb-3 mb-lg-0" alt="Post Event Survey" src="assets/post-event-survey.svg">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <h3 alt="event survey feedback questions" class="feature-heading">POST EVENT SURVEY</h3>
                        <p class="sub-text text-justify">These surveys will provide you with insights that will ensure smooth conduction of your events in the future. The success of any event depends on how your staff and audience are able to connect. Engaging with them regularly post
                            event and addressing their expectations is vital for long term benefits.</p>
                    </div>
                </div>
            </div>
        </div>


        <!-- <div class="container text-center mb-5">
            <p class="text-center">CView Event and Entertainment surveys offer you insights at every stage of the event that gives you valuable details that lead to favorable outcomes.</p>
        </div> -->
    </section>

    <!-- video-section -->
    <section #target class="bg-primary py-lg-5 mt-lg-5 position-relative">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="solution-video">
                        <!-- <video class="embed-responsive embed-responsive-16by9" autoplay [muted]="'muted'" controls loop>
                            <source class="embed-responsive-item" src="assets/video/how-cview-works.mp4"
                                type="video/mp4">
                            Your browser does not support the video tag.
                        </video> -->
                        <iframe width="580" height="335" [src]="safeURL" frameborder="0" allowfullscreen></iframe>

                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
<app-footer></app-footer>